import * as React from 'react';
import { getMe } from 'src/services';
import { IProject } from '../model';
import { defaultGlobalContext, GlobalContext } from './global.context';

type GlobalStateState = typeof defaultGlobalContext;

export class GlobalState extends React.Component<{}, GlobalStateState> {
  public state = {
    ...defaultGlobalContext,
  };

  public toggleIsCreating = () => {
    this.setState({ isCreating: !this.state.isCreating });
  };

  public updateProject = (project: IProject) => {
    this.setState({ project });
  };

  public updateUser = async (logout?: boolean) => {
    if (!logout) {
      const user = await getMe();
      if (user) {
        this.setState({ user });
      }
    } else {
      localStorage.removeItem('beadvize-accessToken');
      localStorage.removeItem('beadvize-accessTokenExpiration');
      this.setState({ user: null });
    }
  };

  public render() {
    return (
      <GlobalContext.Provider
        value={{
          isCreating: this.state.isCreating,
          project: this.state.project,
          toggleIsCreating: this.toggleIsCreating,
          updateProject: this.updateProject,
          updateUser: this.updateUser,
          user: this.state.user,
        }}
      >
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/context/global.state.tsx